import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import { lsHelpers } from '@/helpers';

const me = (data) => {
    if (!_.get(data, 'me.is_admin')) {
        // ensure query finishes before store resets
        setTimeout(() => {
            lsHelpers.logout();
        });
    }
    return data;
};

export default me;
